import API from './index';

export const authAPI = {
  login: (email, password) => API.post('/auth/login', { email, password }),
  logout: () => {
    localStorage.removeItem('adminToken');
    localStorage.removeItem('adminData');
  },
  getToken: () => localStorage.getItem('adminToken'),
  isAuthenticated: () => !!localStorage.getItem('adminToken')
};